import { serviceWorkerFactory } from '../factories/service-worker.factory';
import { SwCheckForUpdateService } from '@qsp-ui-library/services/service-worker-services/sw-check-for-update/sw-check-for-update.service';
import { SwReloadForUpdateService } from '@qsp-ui-library/services/service-worker-services/sw-reload-for-update/sw-reload-for-update.service';
import { APP_BOOTSTRAP_LISTENER, FactoryProvider } from '@angular/core';

export const SERVICE_WORKER_PROVIDER: FactoryProvider = {
  deps: [SwCheckForUpdateService, SwReloadForUpdateService],
  provide: APP_BOOTSTRAP_LISTENER,
  useFactory: serviceWorkerFactory,
  multi: true,
};
